module.exports = {"420324100":"城关镇","420324101":"蒋家堰镇","420324102":"中峰镇","420324103":"水坪镇","420324104":"县河镇","420324105":"泉溪镇","420324106":"丰溪镇","420324107":"龙坝镇","420324108":"兵营镇","420324109":"汇湾镇","420324110":"新洲镇","420324203":"鄂坪乡","420324205":"天宝乡","420324206":"桃源乡","420324207":"向坝乡","420324500":"龙王垭茶场","420324501":"国营竹溪综合农场","420324502":"原种场","420324503":"渔种场","420324504":"种畜场","420324505":"王家山茶场","420324506":"标湖林场","420324507":"双竹林场","420324508":"八卦山林场","420324509":"源茂林场","420324510":"岱王沟林场","420324511":"望府座林场","420324512":"天池垭林场","420324513":"九里岗林场","420324514":"竹溪县十八里长峡管理局"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420324.json
// module id = 1573
// module chunks = 0